import { useTranslation } from 'react-i18next';

import { Button, Stack } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { Projects } from '../../types';
import { SweetAlertIcon } from '../../utils/Constants';
import { extractRootDomain } from '../../utils/Utils';
import Swal from 'sweetalert2';
import { useProjectsData } from '../../hooks/useProjectsData';
import useProjectsManage from '../../hooks/useProjectsManage';


interface Props {
  params: any;
}

const ProjectDelete = ({data, options}) => {
  const { t } = useTranslation();

  const { fetchDeleteProjects, fetchProjects } = useProjectsData();


  const handleDeleteProject = async (project: object) => {

    try {

      const res = await fetchDeleteProjects(project.id);
      // delete from favorites
      const storedFavorites = JSON.parse(localStorage.getItem('favoriteProjects'))
      const updatedProjects = storedFavorites.filter(item => extractRootDomain(item) !== extractRootDomain(project.property))
      localStorage.setItem('favoriteProjects', JSON.stringify(updatedProjects));

      if (res) {
        Swal.fire({
          title: t('Yes!'),
          icon: SweetAlertIcon.SUCCESS,
          text: t('your_project_has_been_successfully_deleted')
        });
        const projects = options.model.projects.filter(item => item.id !== project.id);
        options.model.setProjects(projects);
        await fetchProjects()
      } else {
        Swal.fire({
          title: 'Oh...',
          icon: SweetAlertIcon.INFO,
          text: t('error_occurred_delete_project')
        });
      }
    } catch (error) {
      Swal.fire({ icon: SweetAlertIcon.ERROR, title: 'Oppss...', text: error });
    }
  };

  const handleDeleteProjectSwal = () => {
    Swal.fire({
      title: t('deleteProjectConfirm'),
      icon: SweetAlertIcon.WARNING,
      showCloseButton: true,
      showCancelButton: true,
      cancelButtonText: t('cancel'),
      confirmButtonText: t('delete'),
      confirmButtonColor: '#de3030',
      footer: `<div>${extractRootDomain(data.property)}</div>`
    }).then(async (result) => {
      if (result.isConfirmed) await handleDeleteProject(data);
    });
  };

  return (
    <Stack direction="row" spacing={1} alignItems="center">
      <Button color="error" onClick={(e) => handleDeleteProjectSwal()}>
        <DeleteIcon />
      </Button>
    </Stack>
  );
};

export default ProjectDelete;